export default "__VITE_ASSET__CccdJstB__"